<template>
  <div class="psd2-skipped-container">
    <div class="is-flex">
      <b-icon
        icon="landmark"
        size="is-large"
        class="mr-3 is-grey-icon"
      ></b-icon>

      <div>
        <p class="is-size-5 has-text-weight-bold mb-0">
          {{ $t("af:psd2.skipped_box.title") }}
        </p>

        <p>
          {{ $t("af:psd2.skipped_box.description") }}
        </p>
      </div>
    </div>

    <b-button class="ml-auto" type="is-orange" @click="backToPrelim">{{
      $t("af:psd2.skipped_box.button.back_to_prelim")
    }}</b-button>
  </div>
</template>

<script>
export default {
  name: "Psd2SkippedInfo",
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {
    backToPrelim() {
      this.$router.push("/preliminary-assessment");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors.scss";

.psd2-skipped-container {
  background-color: rgba(241, 156, 28, 0.3);
  border: 1px solid $orange;
  border-radius: 12px;
  padding: 20px;
  display: flex;
}

.button.is-orange {
  background-color: $orange !important;
}

@media only screen and (max-width: 769px) {
  .psd2-skipped-container {
    flex-direction: column;

    button {
      margin-left: 0 !important;
      margin-top: 1rem;
    }
  }
}
</style>
